// import { useHistory } from "react-router-dom"; // Import the 'navigate' function from React Router

export const navigateToPath = (data,path) => {
    window.sessionStorage.setItem("dataPassing", JSON.stringify(data));
    window.location.href=path
    // const history = useHistory();
    // alert(path);
    // history.push(path)  
};
  